var mp = mp || {};

// Litebox
//-----------------------------------------------------------------
mp.fancyBox = function() {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.fancybox({
		thumbs: false,
		fullScreen : false,
		hash: false,
	});
};


// Background image holder
//-----------------------------------------------------------------
mp.backgroundHolder = function() {
    var $element = $(".background-holder");

    if (!$element.length) {
        return;
    }

    $element.each(function(){
        var $img = $(this).find('img');
        var $imageSrc = $img.attr('src');
        $img.remove();
        $(this).css('background-image', 'url('+$imageSrc+')');
    });
};




// ScrollTo
//-----------------------------------------------------------------
mp.scrollTo = function() {
    var $trigger = $("[data-scroll]");

    if (!$trigger.length) {
        return;
    }


    $.extend($.scrollTo.defaults, {
        axis: 'y',
        duration: 800,
        offset: -100,
    });

    $trigger.on('click', function(e) {
        //e.preventDefault();

        setTimeout(function(){
            scrollTo();
        }, 50);
    });

    scrollTo();

    function scrollTo() {
        $hash = $(location).attr('hash');

        if ($hash.length > 1) {
            $target = $hash.replace("#", "");
            $target = "#st-"+$target;
            $target = $($target).children().first();

            $.scrollTo($target);

            $(".header .is_open").removeClass("is_open");
        }
    }
}



// Animate on Scroll
//-----------------------------------------------------------------
mp.animateOnScroll = function () {
    var $element = $('.animated');

    if (!$element.length) {
        return;
    }

    animateDiv();

    $(window).scroll(function() {
        animateDiv();
    });

    function animateDiv() {
        var $topOfWindow = $(window).scrollTop();

        $element.each(function(){
            var $animationType = $(this).data("animation");
            var $contentPos = $(this).offset().top;

            if ($contentPos < $topOfWindow+600) {
                $(this).addClass($animationType).removeClass("animated");

                if ($(this).hasClass("animate_next")) {
                    $(this).next().addClass("slideRight");
                }
            }
        });
    }
}


// Disable image save
//-----------------------------------------------------------------
mp.disableImgSave = function () {
    $("body").on("contextmenu", "img", function(e) {
        return false;
    }); 
}


$(document).ready(function (){
    mp.fancyBox();
    mp.backgroundHolder();
    mp.scrollTo();
    //mp.animateOnScroll();
    mp.disableImgSave();
});